// services/AuthContext.jsx
import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { loadProfilePhoto } from '../utils/photoCache';

export const AppContext = createContext();

const parseCookie = (name) => {
  if (typeof document === 'undefined') return null;
  const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
    const [key, value] = cookie.split('=');
    acc[key] = decodeURIComponent(value || '');
    return acc;
  }, {});
  try {
    return cookies[name] ? JSON.parse(cookies[name]) : null;
  } catch {
    return null;
  }
};

// 👉 Persist ederken avatarUrl’i at
const persistAuth = (auth) => {
  const { avatarUrl, ...plain } = auth || {};
  sessionStorage.setItem('auth', JSON.stringify(plain));
  document.cookie = `auth=${encodeURIComponent(JSON.stringify(plain))}; path=/;`;
  return plain;
};

export const AppProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => {
    const saved = sessionStorage.getItem('auth');
    const fromSession = saved ? JSON.parse(saved) : {
      token: '',
      id: '',
      title: '',
      name: '',
      surname: '',
      email: '',
      telephone: '',
      address: '',
      regdate: '',
      tc: '',
      regstatus: '',
      mobileuser: '',
      updatedate: '',
      password: '',
      profileimage: null,
      // avatarUrl'i asla storage'dan okumuyoruz; hep null başlasın
    };
    const fromCookie = parseCookie('auth') || {};
    return { ...fromSession, ...fromCookie, avatarUrl: null };
  });

  // 📌 Her auth değişiminde PERSIST et (avatarUrl hariç)
  useEffect(() => {
    persistAuth(auth);
  }, [auth]);

  // 🧼 İlk yükleme/yenilemede avatarUrl hydrate et (tek merkez)
  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!auth?.avatarUrl && auth?.id && auth?.profileimage && auth?.token) {
        try {
          const { url } = await loadProfilePhoto({
            id: auth.id,
            fileName: auth.profileimage,
            token: auth.token,
          });
          if (!cancelled) {
            setAuth(prev => ({ ...prev, avatarUrl: url }));
            // DİKKAT: persist etmiyoruz!
          }
        } catch {
          // sessiz geç
        }
      }
    })();
    return () => { cancelled = true; };
  }, [auth?.id, auth?.profileimage, auth?.token, auth?.avatarUrl]);

  return (
    <AppContext.Provider value={{ auth, setAuth }}>
      {children}
    </AppContext.Provider>
  );
};

AppProvider.propTypes = { children: PropTypes.node.isRequired };
